import { createSelector } from 'reselect';

export const getPermissions = state => state.auth.permissions;
export const getPermissionsCases = state => state.auth.permissions.permissions.cases;


export const permissionsSelector = createSelector(getPermissions, permissions => permissions);
export const permissionsCasesSelector = createSelector(getPermissionsCases, permissions => permissions);

